import { useState, useCallback } from 'react'
import { connect } from 'react-redux'
import {
  checkoutTapPayPeriodicAction,
  loadTapPaySDKAction,
} from '../../actions/tapPayActions'
import { roundPrecision, to886, formatNumber } from '../../libs/utils'
import { authenticatedSelector } from '../../reducers/userReducer'
import TableRow from '../babu/TableRow'
import BottomButtonArea from '../common/BottomButtonArea'
import NavBar from '../common/NavBar'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'
import { memberOrGuestIdSelector } from '../libs/selectors'
import TapPayPaymentPage from '../tappay/TapPayPaymentPage'
import AgreeTermsCard from './AgreeTermsCard'
import ConfirmPurchaseTopArea from './ConfirmPurchaseTopArea'
import SelectPaymentCard from './SelectPaymentCard'

// buyerPeriodic: {
//   "title": "定期定額測試",
//   "payment_amount": 18000,  // 應付金額 (台幣)
//   "exchange_rate": 31,      // 台幣兌美元匯率
//   "is_active": true    // 目前是否開放開團/付款
// }

function PurchasePeriodicPage(props) {
  const [openTapPay, setOpenTapPay] = useState(false)
  const [agreed, setAgreed] = useState(false)

  const checkoutButtonCallback = useCallback(() => {
    if (agreed) {
      setOpenTapPay(true)
    }
  }, [agreed, setOpenTapPay])

  const {
    authenticated,
    buyerPeriodic,
    username,
    sentPhone,
    userId,
    orderNo,
    checkoutTapPay,
    loadSDK,
    toPurchaseLoginPage,
  } = props

  const {
    title,
    exchange_rate: exchangeRate,
    order_no: orderNumber,
    payment_amount: amount,
    vendor: vendorInfo,
  } = buyerPeriodic

  const paymentAmountUSD = roundPrecision(amount / exchangeRate)

  const loadSDKCallback = useCallback(() => {
    loadSDK(
      { orderNo },
      sentPhone
        ? {
            orderNo,
            member_id: userId,
            mobile: to886(sentPhone),
          }
        : null,
    )
  }, [orderNo, sentPhone, userId, loadSDK])

  useGA4Pageview('slash_checkout_creditcard')

  if (openTapPay) {
    return (
      <TapPayPaymentPage
        price={amount}
        onCancel={() => setOpenTapPay(false)}
        onCheckout={() => {
          checkoutTapPay(orderNumber)
        }}
        loadSDK={loadSDKCallback}
        toPurchaseLoginPage={toPurchaseLoginPage}
      />
    )
  }

  return (
    <>
      <NavBar />
      <BottomButtonArea
        variant="solid"
        disabled={!agreed}
        onClick={checkoutButtonCallback}>
        {`支付 NT$${formatNumber(amount)}`}
      </BottomButtonArea>
      <ConfirmPurchaseTopArea
        phone={authenticated ? username : sentPhone}
        amount={amount}
        amountUSD={paymentAmountUSD}
      />
      <div className="container px-xs">
        {vendorInfo ? (
          <TableRow
            content="收款商家"
            accessoryLabel={vendorInfo.name}
            divided
          />
        ) : null}
        <TableRow content="名稱" accessoryLabel={title} divided />
      </div>
      <div className="container mt-l mb-30">
        <SelectPaymentCard />
        <AgreeTermsCard
          agreed={agreed}
          setAgreed={setAgreed}
          cardClassName="mt-m"
        />
      </div>
    </>
  )
}

export default connect(
  state => ({
    authenticated: authenticatedSelector(state.user),
    username: state.user.username,
    userId: memberOrGuestIdSelector(state.user, state.sms),
    buyerPeriodic: state.itemEntry.buyerPeriodic,
    sentPhone: state.sms.sentPhone,
  }),
  dispatch => ({
    checkoutTapPay(orderNumber) {
      dispatch(
        checkoutTapPayPeriodicAction({
          order_number: orderNumber,
        }),
      )
    },
    loadSDK(memberQuery, guestPayload) {
      dispatch(loadTapPaySDKAction(memberQuery, guestPayload))
    },
  }),
)(PurchasePeriodicPage)
